<template>
    <div>
        <v-banner class="subtitle-1">
            Müşterileri buradan ekleyebilir, ve goruntuleyebilirsiniz
        </v-banner>

        <v-navigation-drawer
            v-model="filterDrawer"
            absolute
            right
        >
            <template v-slot:prepend>
                <div
                    class="text-h5 transition-swing my-4"
                    v-text="'Müşteri Filtreleri'"
                >
                </div>
            </template>

            <v-divider></v-divider>

            <v-list>
                <v-list-item>
                    <v-list-item-content>

                        <v-select
                            v-model="durumu"
                            :items="musteriDurumlari"
                            item-text="text"
                            item-value="value"
                            label="Makinalar Durumu"
                        />

                    </v-list-item-content>
                </v-list-item>

                <v-divider></v-divider>

                <v-list-item>
                    <v-list-item-content>

                        <v-select
                            v-model="musteriDurumu"
                            :items="makinalarDurumlari"
                            item-text="text"
                            item-value="value"
                            label="Müşteri Durumu"
                        />

                    </v-list-item-content>
                </v-list-item>

                <v-divider></v-divider>

                <v-list-item>
                    <v-list-item-content>
                        <v-select
                            v-model="seciliSehir"
                            :items="sehirler"
                            item-text="text"
                            item-value="value"
                            label="Şehir"
                        />
                    </v-list-item-content>
                </v-list-item>

                <v-divider></v-divider>
            </v-list>
        </v-navigation-drawer>

        <v-data-table
            class="mak-musteri-table"
            :headers="headers"
            :items="filtered"
            :items-per-page="25"
            :search="search"
            item-key="id"
            show-expand
            :single-expand="true"
            :expanded="expanded"
        >
            <template v-slot:top>
                <div class="d-flex justify-space-between align-center">
                    <v-text-field
                        v-model="search"
                        label="Musteri ara"
                        class="mx-4 max-w-xs"
                    />

                    <v-badge
                        color="deep-purple accent-4"
                        dot
                        :value="filterInPlace"
                        offset-x="25"
                        offset-y="0"
                    >
                        <v-icon
                            class="mx-6"
                            @click="filterDrawer = true"
                        >
                            mdi-filter
                        </v-icon>
                    </v-badge>
                </div>
            </template>
            <template v-slot:item.durumu="{ item }">
                <v-chip
                    color="green"
                    dark
                    small
                    v-if="!item.durumu"
                >
                    Kiralık
                </v-chip>
                <v-chip
                    color="orange accent-2"
                    dark
                    small
                    v-else-if="item.durumu === 'demo'"
                >
                    Demo
                </v-chip>
            </template>
            <template v-slot:item.demo_gun_sayisi="{ item }">
                <v-chip
                    v-if="item.durumu === 'demo'"
                    v-show="item.demo_gun_sayisi"
                    color="cyan lighten-1"
                    dark small label
                >
                    {{`${item.demo_gun_sayisi} günlük`}}
                </v-chip>
            </template>
            <template v-slot:item.aktif_mi="{ item }">
                <v-tooltip>
                    <template v-slot:activator="{ on, attrs }">
                        <span v-bind="attrs" v-on="on">
                            <v-icon
                                :color="item.aktif === '1' ? 'green' : 'orange'"
                                text-color="white"
                                @click.stop.prevent="dummy"
                            >
                                {{ item.aktif === '1'
                                ? 'mdi-play-circle'
                                : 'mdi-pause-circle' }}
                            </v-icon>
                        </span>
                    </template>

                    <span>{{item.aktif === '1'
                        ? 'Musteri Durumu: Aktif'
                        : 'Musteri Durumu: Pasif'}}</span>
                </v-tooltip>
            </template>
            <template v-slot:item.makinalar_calisiyor="{ item }">
                <v-tooltip>
                    <template v-slot:activator="{ on, attrs }">
                        <span v-bind="attrs" v-on="on">
                            <v-icon
                                :color="item.makinalar_calismiyor === '1' ? 'orange' : 'green'"
                                text-color="white"
                                @click.stop.prevent="dummy"
                            >
                                {{ item.aktif === '1'
                                ? 'mdi-play-circle-outline'
                                : 'mdi-pause-circle-outline' }}
                            </v-icon>
                        </span>
                    </template>

                    <span>{{item.makinalar_calismiyor === '1'
                        ? 'Makinalar çalışmıyor'
                        : 'Makinalar çalışıyor'}}</span>
                </v-tooltip>
            </template>
            <template v-slot:expanded-item="{ headers, item }">
                <td :colspan="headers.length">
                    <div v-if="item" class="d-flex flex-wrap flex-row justify-start my-6">
                        <router-link :to="{ name: 'musteri-bilgi', params: { id: item.id } }">
                            <v-btn elevation="2" small>
                                <v-icon>mdi-information</v-icon>
                                Bilgi
                            </v-btn>
                        </router-link>
                        <v-btn
                            dark small class="mx-2"
                            :color="item.aktif === '0' ? 'green' : 'orange'"
                            @click="toggle(item.id, item.aktif)">
                            <v-icon>{{item.aktif === '0' ? 'mdi-play' : 'mdi-pause'}}</v-icon>
                            <span v-if="item.aktif === '1'">Pasif et</span>
                            <span v-else>Aktif et</span>
                        </v-btn>
                        <router-link :to="{ name: 'musteri-guncelle', params: { id: item.id } }">
                            <v-btn elevation="2" small>
                                <v-icon>mdi-refresh</v-icon>
                                Güncele</v-btn>
                        </router-link>
                        <v-btn
                            dark small class="mx-2"
                            :color="item.makinalar_calismiyor === '1' ? 'green' : 'orange'"
                            @click="makinalarCalismiyor(item.id, item.makinalar_calismiyor)">
                            <v-icon>{{item.makinalar_calismiyor === '1' ? 'mdi-play' : 'mdi-pause'}}</v-icon>
                            <span v-if="item.makinalar_calismiyor === '0'">Calismiyor</span>
                            <span v-else>Calisiyor</span>
                        </v-btn>
                        <el-popconfirm
                            title="Silmek istediginize emin misiniz?"
                            confirmButtonText="Evet"
                            cancelButtonText="iptal"
                            @onConfirm="remove(item.id)"
                        >
                            <v-btn
                                slot="reference"
                                color="red" dark small>
                                <v-icon>mdi-delete</v-icon>
                                Sil
                            </v-btn>
                        </el-popconfirm>
                    </div>
                </td>
            </template>
        </v-data-table>
    </div>
</template>

<script>
    import { debounce } from 'vue-debounce';

    export default {
        name: 'mak-musteri-listesi',
        props: {
            loading: { type: Boolean },
        },
        data() {
            return {
                musteriDurumu: '1',
                durumu: 'hepsi',
                visible: false,
                list: [],
                expanded: [],
                searchValue: null,
                seciliSehir: null,
                search: null,
                throttleSearch: debounce(s => this.searchValue = s, 400),
                musteriDurumlari: [
                    { text: 'Hepsi', value: 'hepsi' },
                    { text: 'Kiralik', value: 'kiralik' },
                    { text: 'Demo', value: 'demo' },
                ],
                makinalarDurumlari: [
                    { text: 'Hepsi', value: null },
                    { text: 'Aktif', value: '1' },
                    { text: 'Pasif', value: '0' },
                    { text: 'Makinasi çalışmayanlar', value: '2' },
                ],
                sehirler: [
                    { text: 'Hepsi', value: null },
                    { text: 'Sakarya', value: 'Sakarya' },
                    { text: 'Kocaeli', value: 'Kocaeli' },
                ],
                filterDrawer: false,
            };
        },
        computed: {
            clearSearch() {
                return this.search?.trim();
            },
            params() {
                return {
                    q: this.searchValue,
                    d: this.musteriDurumu,
                    k: this.durumu,
                };
            },
            headers() {
                return [
                    { text: `Şirket (${this.count})`, value: 'sirket_adi' },
                    { text: 'Durumu', value: 'durumu' },
                    { text: 'Demo Gün', value: 'demo_gun_sayisi' },
                    { text: '', value: 'aktif_mi' },
                    { text: '', value: 'makinalar_calisiyor' },
                ];
            },
            filterInPlace() {
                return this.musteriDurumu || this.durumu !== 'hepsi' || this.seciliSehir;
            },
            filtered() {
                let list = this.list.slice();
                if (this.musteriDurumu) {
                    //
                    if (this.musteriDurumu === '2') {
                        list = list.filter(a => a.makinalar_calismiyor === '1');
                    } else {
                        list = list.filter(a => a.aktif === this.musteriDurumu);
                    }
                }
                if (this.durumu !== 'hepsi') {
                    //
                    if (this.durumu === 'demo') {
                        list = list.filter(a => a.durumu === 'demo');
                    } else {
                        list = list.filter(a => a.durumu !== 'demo');
                    }
                }

                if (this.searchValue) {
                    list = list.filter(a => a.sirket_adi.toLowerCase().includes(this.searchValue.toLowerCase()));
                }

                if (this.seciliSehir) {
                    list = list.filter(a => a.sehir === this.seciliSehir);
                }
                return list;
            },
            count() {
                return this.filtered.length;
            },
        },
        methods: {
            dummy() {
            },
            go(id) {
                this.$router.push({
                    name: 'musteri-bilgi',
                    params:  {
                        id,
                    },
                });
            },
            goMusteri(row, column) {
                const { property } = column;
                if (property === 'actions') {
                    return;
                }

                this.go(row.id);
            },
            fetch() {
                this.$emit('update:loading', true);
                this.$requests.Musteri.getMusteri()
                    .then((data) => {
                        this.list = data;
                    })
                    .catch((e) => {
                        console.error('error', e);
                    })
                    .then(() => {
                        this.$emit('update:loading', false);
                    });
            },
            remove(id) {
                this.$emit('update:loading', true);
                this.$requests.Musteri.deleteMusteri(id)
                    .then(() => {
                        this.fetch();
                    })
                    .catch((e) => {
                        this.$emit('update:loading', false);
                        console.error('error', e);
                    });
            },
            toggle(id, aktif) {
                this.$emit('update:loading', true);
                this.$requests.Musteri.toggleMusteriAktif(id, aktif)
                    .then(() => {
                        // refresh data
                        this.fetch();
                    })
                    .catch((e) => {
                        console.error('error toggling sirket aktif', e);
                    })
                    .then(() => {
                        this.$emit('update:loading', false);
                    });
            },
            makinalarCalismiyor(id, makinalarCalismiyor) {
                this.$emit('update:loading', true);
                this.$requests.Musteri
                    .toggleMakinalarCalismiyor(id, makinalarCalismiyor)
                    .then(() => {
                        // refresh data
                        this.fetch();
                    })
                    .catch((e) => {
                        console.error('error toggling sirket aktif', e);
                    })
                    .then(() => {
                        this.$emit('update:loading', false);
                    });
            },
        },
        created() {
            const { q, d, k } = this.$route.query;
            if (d) {
                this.musteriDurumu = d;
            }
            if (k) {
                this.durumu = k;
            }
            if (q) {
                this.search = q;
                this.searchValue = q;
            }
        },
        mounted() {
            this.fetch();
        },
        watch: {
            clearSearch() {
                this.throttleSearch(this.clearSearch);
            },
            params() {
                this.$router.replace({ name: this.$route.name, query: this.params });
            },
        }
    };
</script>

<style lang="scss">
    .mak-musteri-table {
        .v-data-table__expanded {
            a {
                text-decoration: none;
            }
        }
    }
</style>
